export const MAP_UTILITIES_UNIT_SELECTION_SET = "MAP_UTILITIES_UNIT_SELECTION_SET";